import { useApp } from '../../../../app/AppContext.jsx'
import { useProduct } from '../../index.js'
import { useI18n } from '../../../../shared/i18n/useI18n.js'

import styles from './DisclaimerPane.module.scss'

/**
 * DisclaimerPane — renders the main disclaimer below pricing/actions.
 *
 * Priority:
 *  1. Product has a matching turnkey style with a non-empty disclaimer.text_html
 *     → render that HTML
 *  2. panelSettings.unit_main_disclaimer.disclaimer.text_html is non-empty
 *     → render that HTML
 *  3. Default localised fallback string
 */
export function DisclaimerPane() {
  const { t } = useI18n()
  const { panelSettings } = useApp()
  const { selection } = useProduct()
  const { product } = selection

  const turnkeyStyles = panelSettings?.turn_key_styles?.styles ?? []
  const productTurnkeyLabel = product?.turn_key_style ?? null

  const matchedStyle = productTurnkeyLabel
    ? turnkeyStyles.find(
        (s) => s.in_use && s.label === productTurnkeyLabel,
      )
    : null

  const turnkeyDisclaimerHtml = matchedStyle?.disclaimer?.text_html ?? ''
  const mainDisclaimerHtml = panelSettings?.unit_main_disclaimer?.disclaimer?.text_html ?? ''

  let content = null

  if (turnkeyDisclaimerHtml) {
    content = <div dangerouslySetInnerHTML={{ __html: turnkeyDisclaimerHtml }} />
  } else if (mainDisclaimerHtml) {
    content = <div dangerouslySetInnerHTML={{ __html: mainDisclaimerHtml }} />
  } else {
    content = <p>{t('product.main_disclaimer_default')}</p>
  }

  return (
    <div className={styles.disclaimerPane}>
      {content}
    </div>
  )
}
